import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'awards',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Awards',
    display: {
      isMain: true,
      position: 0,
    },
    name: 'Awards',
    page: { alias: 'sr:awards' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
